import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from '@heroicons/react/24/solid';

const BrandLoginPrompt = ({ brands = [], onLogin }) => {
  const { t } = useTranslation();

  const safeBrands = (Array.isArray(brands) ? brands : []).filter(Boolean);
  const hasBrands = safeBrands.length > 0;

  const visible = safeBrands.slice(0, 4);
  const hasExtra = safeBrands.length > 4;

  return (
    <div className="bg-white rounded-3xl shadow-md border border-gray-200 p-6">
      <h3
        className={[
          'text-center text-gray-400 leading-tight',
          hasBrands ? 'font-semibold text-xl' : 'italic p-12',
        ].join(' ')}
      >
        {hasBrands ? (
          <>
            {t('event_detail.some_confirmed')} <br />
            {t('event_detail.brands_at_event')}
          </>
        ) : (
          t('event_detail.no_brands_confirmed')
        )}
      </h3>

      {hasBrands ? (
        <div className="mt-6 flex items-center justify-center gap-2">
          {visible.map((b, idx) => (
            <div
              key={b.id ?? `${b.username || b.name || 'brand'}-${idx}`}
              className="w-16 h-16 shrink-0 rounded-full overflow-hidden ring-1 ring-gray-200 bg-white"
              title={b.username || b.name}
            >
              <img
                src={b.logo || b.avatar || b.image}
                alt={b.username || b.name || 'brand'}
                className="w-full h-full object-cover"
                loading="lazy"
                draggable={false}
              />
            </div>
          ))}

          {hasExtra && (
            <div className="w-16 h-16 flex items-center justify-center text-gray-400 text-4xl font-light select-none">
              <PlusIcon className="w-6 h-6" />
            </div>
          )}
        </div>
      ) : (
        <div className="mt-10" />
      )}

      <hr className="my-3 border-gray-300" />

      <p className="text-center text-gray-400 mb-2 text-sm">
        {t('event_detail.want_to_secure')}
      </p>

      <button
        type="button"
        onClick={onLogin}
        className="w-full py-4 rounded-full bg-yellow-05 text-white font-semibold hover:bg-yellow-500 transition shadow-sm"
      >
        {t('event_detail.login_as_brand', 'Login as brand')}
      </button>
    </div>
  );
};

export default BrandLoginPrompt;
